export const fieldsQuantitative = [
  "PlantGrowth_Height",
  "PlantGrowth_Collar_Diameter",
  "Canopy_cover",
  "Moisture_content",
  "Survivability",
  // new changes - tag v3.0.1
  "Nitrogen",
  "Phosphate",
  "Potassium",
  "Soil_PH",
  "Soil_Temperature",
  "Soil_Moisture",
  "Electrical_Conductivity",
  // "Plant_Status",
];
export const fieldsQualitative = [
  "PlantGrowth_Flower_Count",
  "PlantGrowth_Fruit_Count",
  "Leaf_bud_formation",
  "Leaf_fall",
  "Flower_Bud_Formation",
  "Open_Flower",
  "Fruit_Seed_Formation",
  "Fruit_Seed_Ripe",
  "Fruit_Seed_Fall",
  // new changes - tag v3.0.1
  // "Plant_Status",
];

export const getMonitoringData = (item, quantitative, qualitative) => {
  if (item?.Plantation_Monitoring_Type === "Quantitative Monitoring") {
    return [
      { title: "Canopy Cover (cm)", value: quantitative?.Canopy_cover ?? null },
      {
        title: "Moisture Content (%)",
        value: quantitative?.Moisture_content ?? null,
      },
      {
        title: "Collar Diameter (cm)",
        value: quantitative?.PlantGrowth_Collar_Diameter ?? null,
      },
      {
        title: "Plant Height (m)",
        value: quantitative?.PlantGrowth_Height ?? null,
      },
      {
        title: "Plant Survivability",
        value: quantitative?.Survivability ?? null,
      },
      // new changes - tag v3.0.1

      { title: "Nitrogen (mg)", value: quantitative?.Nitrogen ?? null },
      { title: "Phosphate (mg)", value: quantitative?.Phosphate ?? null },
      { title: "Potassium (mg)", value: quantitative?.Potassium ?? null },
      { title: "Soil (ph)", value: quantitative?.Soil_PH ?? null },
      {
        title: "Soil Temperature (c)",
        value: quantitative?.Soil_Temperature ?? null,
      },
      {
        title: "Soil Moisture (%)",
        value: quantitative?.Soil_Moisture ?? null,
      },
      {
        title: "Electrical Conductivity (ds/cm)",
        value: quantitative?.Electrical_Conductivity ?? null,
      },
      // {
      //   title: "Plant Status",
      //   value: quantitative?.Plant_Status ?? null,
      // },
    ];
  } else {
    return [
      { title: "Open Flower", value: qualitative?.Open_Flower ?? null },
      {
        title: "Flower Count",
        value: qualitative?.PlantGrowth_Flower_Count ?? null,
      },
      {
        title: "Fruit Count",
        value: qualitative?.PlantGrowth_Fruit_Count ?? null,
      },
      {
        title: "Flower Bud Formation",
        value: qualitative?.Flower_Bud_Formation ?? null,
      },
      { title: "Fruit Seed Fall", value: qualitative?.Fruit_Seed_Fall ?? null },
      {
        title: "Fruit Seed Formation",
        value: qualitative?.Fruit_Seed_Formation ?? null,
      },
      { title: "Fruit Seed Ripe", value: qualitative?.Fruit_Seed_Ripe ?? null },
      {
        title: "Leaf Bud Formation",
        value: qualitative?.Leaf_bud_formation ?? null,
      },
      { title: "Leaf Fall", value: qualitative?.Leaf_fall ?? null },
      // new changes - tag v3.0.1

      // {
      //   title: "Plant Status",
      //   value: qualitative?.Plant_Status ?? null,
      // },
    ];
  }
};

export const getQuantitativeData = (quantitative) => {
  return [
    {
      title: "Plant Growth Height (m)",
      value: quantitative?.PlantGrowth_Height ?? null,
    },
    { title: "Canopy Cover (cm)", value: quantitative?.Canopy_cover ?? null },
    {
      title: "Moisture Content (%)",
      value: quantitative?.Moisture_content ?? null,
    },
    {
      title: "Collar Diameter (cm)",
      value: quantitative?.PlantGrowth_Collar_Diameter ?? null,
    },
    {
      title: "Plant Survivability",
      value: quantitative?.Survivability ?? null,
    },
    // new changes - tag v3.0.1

    { title: "Nitrogen (mg)", value: quantitative?.Nitrogen ?? null },
    { title: "Phosphate (mg)", value: quantitative?.Phosphate ?? null },
    { title: "Potassium (mg)", value: quantitative?.Potassium ?? null },
    { title: "Soil (ph)", value: quantitative?.Soil_PH ?? null },
    {
      title: "Soil Temperature (c)",
      value: quantitative?.Soil_Temperature ?? null,
    },
    {
      title: "Soil Moisture (%)",
      value: quantitative?.Soil_Moisture ?? null,
    },
    {
      title: "Electrical Conductivity (ds/cm)",
      value: quantitative?.Electrical_Conductivity ?? null,
    },
    // {
    //   title: "Plant Status",
    //   value: quantitative?.Plant_Status ?? null,
    // },
  ];
};

export const getQualitativeData = (qualitative) => {
  return [
    { title: "Open Flower", value: qualitative?.Open_Flower ?? null },
    {
      title: "Flower Count",
      value: qualitative?.PlantGrowth_Flower_Count ?? null,
    },
    {
      title: "Fruit Count",
      value: qualitative?.PlantGrowth_Fruit_Count ?? null,
    },
    {
      title: "Flower Bud Formation",
      value: qualitative?.Flower_Bud_Formation ?? null,
    },
    { title: "Fruit Seed Fall", value: qualitative?.Fruit_Seed_Fall ?? null },
    {
      title: "Fruit Seed Formation",
      value: qualitative?.Fruit_Seed_Formation ?? null,
    },
    { title: "Fruit Seed Ripe", value: qualitative?.Fruit_Seed_Ripe ?? null },
    {
      title: "Leaf Bud Formation",
      value: qualitative?.Leaf_bud_formation ?? null,
    },
    { title: "Leaf Fall", value: qualitative?.Leaf_fall ?? null },
    // new changes - tag v3.0.1

    // {
    //   title: "Plant Status",
    //   value: qualitative?.Plant_Status ?? null,
    // },
  ];
};
export const filterFields = (object, fieldsArray) => {
  const filterdObject = Object.fromEntries(
    Object.entries(object).filter(([key, value]) => fieldsArray.includes(key))
  );
  return filterdObject;
};
